import { render, staticRenderFns } from "./tabTest.vue?vue&type=template&id=3ff6e671&scoped=true"
import script from "./tabTest.vue?vue&type=script&lang=js"
export * from "./tabTest.vue?vue&type=script&lang=js"
import style0 from "./tabTest.vue?vue&type=style&index=0&id=3ff6e671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff6e671",
  null
  
)

export default component.exports